// extracted by mini-css-extract-plugin
export default {"primary":"ButtonActions_primary__8LcQL","outline":"ButtonActions_outline__kQ8j5","danger":"ButtonActions_danger__IfCs9"};